<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/plates/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Rendszám</h1>
          <div class="row">
            <div class="col-xs-6">
              <inputbox id="owner_name" label="Tulajdonos neve" v-bind:errors="errors" name="owner_name" disabled v-model="form.owner_name"></inputbox>
              <inputbox v-if="up_email != ''" disabled id="up_email" label="E-mail cím" name="up_email" v-model="up_email"></inputbox>
              <inputbox v-if="email != ''" disabled id="email" label="E-mail cím" name="email" v-model="email"></inputbox>
              <inputbox id="card_number" label="Kártyaszám" v-bind:errors="errors" name="card_number" disabled v-model="form.card_number"></inputbox>
              <inputbox id="number" label="Rendszám" v-bind:errors="errors" name="number" v-model="form.number"></inputbox><i v-if="form.active_season_ticket" class="fa fa-exclamation-circle fa-lg" style="color: #C25450;"><span style="padding: 2px; font-family: 'Open Sans';">Bérlethez rendelt rendszám.</span></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      form: {
        id: 0,
        number: '',
        owner_name: '',
        card_number: ''
      },
      email: '',
      up_email: '',
      errors: [],
      is_save: false
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('plate/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.plateID != undefined ? _this.$route.query.plateID : 0), {
        success: function(response) {
          _this.form = response.plate;
          _this.email = response.email;
          _this.up_email = response.up_email;
        }
      });
    });
  },

  methods: {
    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('plate/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              _this.$router.push({path: '/plates'});
            }
          }
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// plate.vue?ccee8ac6